<template>
    <div>
        <div class="header mt-5">
            {{ $vuetify.lang.t('$vuetify.inquiry.inquiryAndAttendance') }}
        </div>
        <nav-bar
            ref="navbar"
            @menu-change="menuChange"
            :menuItem="navbarList">
        </nav-bar>

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Inquiry from '@/components/InquiryAndAttendance/Inquiry.vue'
import InquiryLeave from '@/components/InquiryAndAttendance/InquiryLeave.vue'
import ManageAttendance from '@/components/InquiryAndAttendance/ManageAttendance.vue'
import StatusAttendance from '@/components/InquiryAndAttendance/StatusAttendance.vue'
import OvertimeRequest from '@/components/InquiryAndAttendance/OvertimeRequest.vue'
import CheckInLocation from '@/components/InquiryAndAttendance/CheckInLocation.vue'
import PunchLog from '@/components/InquiryAndAttendance/PunchLog.vue'
import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'InquiryAndAttendance',

    components: {
        NavBar,
        Inquiry,
        InquiryLeave,
        ManageAttendance,
        StatusAttendance,
        OvertimeRequest,
        PunchLog,
        CheckInLocation
    },

    computed: {
        navbarList () {
            const navbarList = []
            for (let i = 0; i < this.menuItem.length; i++) {
                const show = this.menuItem[i].permission.some(p => this.userPermissions.includes(p))
                if (show) {
                    navbarList.push(this.menuItem[i])
                }
            }
            return navbarList
        }
    },

    data () {
        return {
            component: 'Inquiry',
            userPermissions: [],
            menuItem: [
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.inquiry'),
                    path: 'Inquiry',
                    pathName: 'inquiry',
                    permission: [permissionConstant.inquiry.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.inquiryLeave'),
                    path: 'InquiryLeave',
                    pathName: 'inquiry-leave',
                    permission: [permissionConstant.inquiry.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.statusAttendance'),
                    path: 'StatusAttendance',
                    pathName: 'status-attendance',
                    permission: [permissionConstant.attendance.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.manageAttendance'),
                    path: 'ManageAttendance',
                    pathName: 'manage-attendance',
                    permission: [permissionConstant.attendance.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.overtimeRequest'),
                    path: 'OvertimeRequest',
                    pathName: 'overtime-request',
                    permission: [permissionConstant.attendance.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.punchLog'),
                    path: 'PunchLog',
                    pathName: 'punch-log',
                    permission: [permissionConstant.punchlog.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.inquiry.checkInLocation'),
                    path: 'CheckInLocation',
                    pathName: 'check-in-location',
                    permission: [permissionConstant.attendance.view]
                }
            ],
            mappedTranslation: {
                Inquiry: 'inquiry',
                StatusAttendance: 'statusAttendance',
                ManageAttendance: 'manageAttendance',
                OvertimeRequest: 'overtimeRequest',
                PunchLog: 'punchLog',
                CheckInLocation: 'checkInLocation',
                InquiryLeave: 'inquiryLeave'
            }
        }
    },

    methods: {
        menuChange (payload) {
            this.component = payload.path

            const path = `/inquiry-and-attendance/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navbarPermission () {
            this.component = this.navbarList[0].path
        },

        hideServiceFromEnv () {
            if (process.env.VUE_APP_PUNCH_LOG === 'false') {
                const indexOfPinMenu = this.menuItem.findIndex((menu, index) => {
                    if (menu.path === 'PunchLog') {
                        return true
                    }
                })

                this.menuItem.splice(indexOfPinMenu, 1)
            }

            if (process.env.VUE_APP_CHECK_IN_LOCATION === 'false') {
                const indexOfCheckInLocationMenu = this.menuItem.findIndex((menu, index) => {
                    if (menu.path === 'CheckInLocation') {
                        return true
                    }
                })

                this.menuItem.splice(indexOfCheckInLocationMenu, 1)
            }
        },

        setLangNavBar () {
            for (let i = 0; i < this.menuItem.length; i++) {
                if (this.mappedTranslation[this.menuItem[i].path]) {
                    this.menuItem[i].title = this.$vuetify.lang.t(`$vuetify.inquiry.${this.mappedTranslation[this.menuItem[i].path]}`)
                }
            }
        },

        setActive (path) {
            let index = 0
            if (path === 'InquiryAndAttendance') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/inquiry-and-attendance/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.hideServiceFromEnv()
        this.userPermissions = this.$store.state.permissions
        this.navbarPermission()
        this.setActive(this.$router.currentRoute.name)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangNavBar()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
</style>
